import React from "react";
import PropTypes from 'prop-types';
import vector1 from '../../../../images/vector1.svg'
import vector2 from '../../../../images/vector2.svg'
import vector3 from '../../../../images/vector3.svg'
import raster1 from '../../../../images/raster1.svg'
import raster2 from '../../../../images/raster2.svg'
import raster3 from '../../../../images/raster3.svg'
import group1 from '../../../../images/group1.svg'
import group2 from '../../../../images/group2.svg'
import group3 from '../../../../images/group3.svg'
import collapseImg from '../../../../images/collapse_gray.svg'
import loadingImg from '../../../../images/loading.gif'
import styles from './layer-element.module.css'
import { WMS, Tileset, TMS, GeoJSON, ArcgisMapserver, Terrain, PointCloud } from '../../../../utils/layer-types'
import { useDispatch, useSelector } from "react-redux";
import { changeCollaps, changeVisible, changeOpacity, getChildLayers } from "../../../../services/reducers/map";
import { setTerrain } from "../../../../services/reducers/terrain";


export default function LayerElement({
    layer
}) {
    const dispatch = useDispatch();
    let {
        label,
        type,
        collapsed = true,
        visible,
        selected = false,
        opacity,
    } = layer;
    let elementsComponent = undefined;
    const elements = useSelector(state => getChildLayers(state, layer));
    if (elements && elements.length) {
        elementsComponent = (
            <div className={`${styles.elementsContainer} ${collapsed ? styles.collapsed : ''}`}>
                {elements.map((l) => (
                    <LayerElement
                        key={l.id}
                        layer={l}
                    />
                ))}
            </div>
        );
    }
    let icon;
    let isLayerLoading = isLoading(layer);
    if (isLayerLoading) {
        icon = loadingImg;
    }
    else
        switch (type) {
            case GeoJSON:
                icon = visible === true ? vector1 : visible === null ? vector2 : vector3;
                break;

            case Tileset:
            case PointCloud:
            case WMS:
            case ArcgisMapserver:
            case TMS:
            case Terrain:
                icon = visible === true ? raster1 : visible === null ? raster2 : raster3;
                break;

            default:
                icon = visible === true ? group1 : visible === null ? group2 : group3;
                break;
        }

    const opacityMin = 0.6, opacityMax = 1.0;
    let progress = opacity ? ((opacity - opacityMin) / (opacityMax - opacityMin) * 100) : 100;
    const onVisibleChange = () => {
        if (type !== Terrain){
            dispatch(changeVisible(layer))
        }
        else if (!visible) {
            dispatch(setTerrain(layer));
        }
    }
    return (
        <div className={styles.layerElementContainer}>
            <div className={styles.layerElement}>
                {elements && elements.length
                    ? (<img
                        className={collapsed === true ? styles.groupElementImgCollapsed : styles.groupElementImg}
                        src={collapseImg}
                        alt='collapse'
                        onClick={() => dispatch(changeCollaps({ ...layer, collapsed: !collapsed }))}
                    ></img>)
                    : (<div className={styles.layerElementImg} ></div>)
                }

                {/* <Checkbox checked={visible == true} indeterminate={visible == null} onChange={() => changeLayerVisible(layer, parents)} /> */}
                <div className={styles.imgContainer}><img className={styles.layerElementImg} src={icon} alt={label} onClick={() => { if (!isLayerLoading) onVisibleChange(); }} /></div>
                <div className={`${styles.labelContainer} ${selected ? styles.selected : ''}`}>
                    <div className={styles.label}>{label}</div>
                    {[Tileset, TMS].includes(type) && <input className={styles.range} type="range" min={opacityMin} max={opacityMax} step="0.01"
                        value={opacity ? opacity : opacityMax}
                        style={{ background: `linear-gradient(to right, rgba(230, 159, 106, 0.4) ${progress}%, rgba(230, 159, 106, 0.1) ${progress}%)` }}
                        onChange={(event) => {
                            dispatch(changeOpacity({ ...layer, opacity: Number(event.target.value) }));
                        }} />}
                </div>
            </div>
            {elementsComponent}
        </div>
    )
}

const layerShape = {
    id: PropTypes.number.isRequired,
    parentId: PropTypes.number,
    label: PropTypes.string.isRequired,
    type: PropTypes.string,
    collapsed: PropTypes.bool,
    visible: PropTypes.oneOf([true, false, null]),
    selected: PropTypes.bool,
    loading: PropTypes.bool,
    opacity: PropTypes.number
};
// layerShape.elements = PropTypes.arrayOf(PropTypes.shape(layerShape));
export const layerType = PropTypes.shape(layerShape);

LayerElement.propTypes = {
    layer: layerType.isRequired
};

function isLoading(layer) {
    return layer.loading || (layer.elements && layer.elements.some(l => isLoading(l)));
}